import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Microservices } from 'src/app/core/constants/pol.enums';
import { IDowntimeMessageResponse, UmbracoApiResponse } from 'src/app/core/models/global.model';

@Injectable({
  providedIn: 'root'
})
export class DowntimeMessageService {
  constructor(private http: HttpClient) {
  }

  getDownTimeMessages(guid: string): Observable<IDowntimeMessageResponse[]> {
    const url = `${Microservices.UmbracoCMS}/ContentData/${guid}`;
    return this.http.get<UmbracoApiResponse<IDowntimeMessageResponse[]>>(url).pipe(
      map(res => res.contents)
    );
  }
}
